import {Localizer} from "../../../infrastructure/localization/localizer";
import React, {useState} from "react";
import useScreenResolution from "../../../core/hooks/useScreenResolution";
import DashboardCardSettings from "../dashboardCardSettings";
import {DashboardCardSettingsOption} from "../models/DashboardCardSettingsOption";
import classNames from "classnames";
import useDashboardUddannelsesplaner from "./useDashboardUddannelsesplaner";
import {EmblaIllustration} from "../../../core/components/emblaIcon/emblaIllustration";
import {Loading} from "../../../core/components/loading/loading";
import MultiLevelPieChart from "../dashboardCharts/multiLevelPieChart";
import {LegendPlacement} from "../models/LegendPlacement";
import {SimpleBarChart} from "../dashboardCharts/simpleBarChart";

type DashboardUddannelsesplanerProps = {}
const DashboardUddannelsesplaner = ({}: DashboardUddannelsesplanerProps) => {
    const {isMobile} = useScreenResolution();
    const [showLabelsUddannelsesplaner, setShowLabelsUddannelsesplaner] = useState<boolean>(false);

    const {
        uddannelsesplanerStatusPieChart,
        uddannelsesplanerIsLoading,
        uddannelsesplanerTidSidenSidste,
        uddannelsesplanerTidSidenSidsteTotalAmount,
        uddannelsesplanerFoersteTotalAmount,
        uddannelsesplanerTotalAmount,
        uddannelsesplanerBarChart
    } = useDashboardUddannelsesplaner();

    const settingsOption: DashboardCardSettingsOption = {
        checkedValue: showLabelsUddannelsesplaner,
        setCheckedValue: setShowLabelsUddannelsesplaner,
        label: Localizer.dashboard_showLabelValues()
    };

    const noResults = uddannelsesplanerTotalAmount <= 0 && !uddannelsesplanerIsLoading;

    return <>
        <div className="card ">
            <div className="card-header">
                <h4 className="card-title">{Localizer.global_uddannelsesplaner()}</h4>
                <DashboardCardSettings id={"settings-uddannelsesplaner-icon-id"}
                                       options={[settingsOption]}/>
            </div>
            <div className={classNames("card-body d-flex", noResults && "justify-content-center")}>
                <Loading isLoading={uddannelsesplanerIsLoading} text={Localizer.global_uddannelsesplaner()}
                         hideContentOnPreload={false}>
                    {noResults
                        ?
                        <div className={"flex-container-column align-items-center padding-m"}>
                            <EmblaIllustration illustrationName={"failure-mark"} additionalClasses={"subtle"}/>
                            <h4 className={"subtle"}> {Localizer.global_NoResultsFromFilter()} </h4>
                        </div>
                        :
                        <div className={classNames("flex-container-row flex-fill wrap flex-space-between")}>
                            <div className={classNames(!isMobile && "border dashboard-card-border-radius graph-w-49")}>
                                <div className={classNames(!isMobile && "margin-m")}>
                                    <h4>{Localizer.dashboard_uddannelsesplanerAmount()}</h4>
                                </div>
                                {uddannelsesplanerBarChart &&
                                    <SimpleBarChart dataset={uddannelsesplanerBarChart}
                                                    totalAmount={uddannelsesplanerTotalAmount}
                                                    hideLegends
                                                    xLabel={Localizer.dashboard_uddannelsesplanerAmount()}
                                                    yLabel={Localizer.global_uddannelseslaeger()}
                                                    heightOverride={430}
                                    />
                                }
                            </div>
                            <div
                                className={classNames("flex-fill", !isMobile && " border dashboard-card-border-radius")}>
                                <MultiLevelPieChart datasets={uddannelsesplanerStatusPieChart}
                                                    diagramTitle={Localizer.dashboard_uddannelsesplan()}
                                                    totalAmount={uddannelsesplanerFoersteTotalAmount}
                                                    showLabels={showLabelsUddannelsesplaner}
                                                    overrideInnerRadius={0}
                                                    legendPlacement={LegendPlacement.Bottom}
                                                    showLegendLabels={false}
                                                    showCenterLabel
                                />
                            </div>
                            <div
                                className={classNames("flex-fill", !isMobile && "border dashboard-card-border-radius")}>
                                <MultiLevelPieChart datasets={uddannelsesplanerTidSidenSidste}
                                                    diagramTitle={Localizer.dashboard_tidSidenSenesteUddannelsesplan()}
                                                    totalAmount={uddannelsesplanerTidSidenSidsteTotalAmount}
                                                    showLabels={showLabelsUddannelsesplaner}
                                                    overrideInnerRadius={0}
                                                    legendPlacement={LegendPlacement.Bottom}
                                                    showLegendLabels={false}
                                                    showCenterLabel
                                />
                            </div>
                        </div>
                    }
                </Loading>

            </div>
        </div>
    </>
}
export default DashboardUddannelsesplaner;
